import React, {useEffect, useState} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {Checkbox} from '@mui/material';
import {get} from 'react-scroll/modules/mixins/scroller';
import Dropdown from 'react-dropdown';
import axios from 'axios';

export const CatServActivos = (props) => {
	const {
		Usuario,
		Categorias,
		Servicios,
		setServicio,
		setActivar,
		setModalActivarDesactivar,
		sedeId,
		sedes,
		serviciosSedes,
		setServiciosSedes,
	} = props;

	const [estado, setEstado] = useState('activo');

	useEffect(() => {
		setActivar(false);
	});

	const activarServico = (ServiciosActivo, sede) => {
		setServicio(ServiciosActivo);
		sedeId.push(sede);
		setModalActivarDesactivar(true);
	};

	const seleccionarSede = (sede) => {
		axios({
			method: 'get',
			url:
				window.ipdirection +
				'Servicio_Empresa_SedePrestador_Estado/?sede=' +
				sede +
				'&estado=' +
				estado,
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			},
		}).then((response) => {
			console.log(response.data)
			setServiciosSedes(response.data);
		});
	};

	const añadirSede = (sede_id) => {
		if (!sedeId.includes(sede_id)) {
			// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
			sedeId.push(sede_id);
		} else {
			// Actualizamos el estado de sedeSeleccionada con los atributos de la sede seleccionada.
			sedeId.splice(sedeId.indexOf(sede_id), 1);
			delete sedeId[sede_id];
		}
	};

	return (
		<>
			<div className='Body-CatServActivos'>
				<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
					{sedes === undefined ? (
						<></>
					) : (
						<Dropdown
							className='dropDown-añaidrServicio-empresa '
							options={sedes.map((sede) => {
								return sede.nombreSede;
							})}
							onChange={(e) => seleccionarSede(e.value)}
							placeholder={'-- Selecionar --'}
						/>
					)}
				</div>
				<div className='categorias-CatServActivos categoriasActivas-CatServActivos'>
					<div className='title-CatServActivos title-1'>
						<h2>Categorias</h2>
						<div className='separador' />
					</div>
					<div className='lista-categoria-CatServActivos lista-categoriaActivas-CatServActivos'>
						{Categorias.map((categoria) => (
							<div className='categoria-CatServActivos categoriaActivas-CatServActivos'>
								<div className='title-CatServActivos title-3'>
									{categoria.categoria_id.nombre}
								</div>
								<div className=''>
									{categoria.categoria_id.superCategoria === 1 &&
										'Servicio Sanitario'}
									{categoria.categoria_id.superCategoria === 2 &&
										'Servicio Socio Sanitario'}
									{categoria.categoria_id.superCategoria === 3 && 'Otros'}
								</div>
							</div>
						))}
					</div>
				</div>
				<div className='servicios-CatServActivos serviciosActivas-CatServActivos'>
					<div className='title-CatServActivos title-1'>
						<h2>Servicios</h2>
						<div className='separador' />
					</div>
					{serviciosSedes != ''
						? Categorias.map((categoria) => (
								<div className='servicio-CatServActivos servicioActivo-CatServActivos'>
									<div className='title-CatServActivos title-2 title-servicios-CatServActivos'>
										<h3>Servicios de {categoria.categoria_id.nombre}</h3>
									</div>
									<div className='separador' />
									<div className='lista-servicio-CatServActivos '>
										{Servicios.map(
											(servicio) =>
												servicio.servicio_id.categoria_id.id ===
													categoria.categoria_id.id &&
												serviciosSedes.map(
													(serviciosSede) =>
														servicio.id ===
															serviciosSede.servicio_id && (
															<div className='card-servicio-CatServActivos'>
																<div
																	className='title-CatServActivos title-3 title-servicio-CatServActivos'
																	onClick={() =>
																		activarServico(
																			servicio.id,
																			serviciosSede.sede_id
																		)
																	}
																>
																	<div className='centrador'>
																		{servicio.servicio_id
																			.nombre +
																			' - ' +
																			categoria.categoria_id
																				.nombre}
																	</div>
																	<div className='button borrarCuenta'>
																		<div>Desactivar</div>
																	</div>
																</div>
																<div className='separador' />
																<div className='descripcion-servicio'>
																	{servicio.descripcion}
																</div>
																<div className='descripcion-servicio'>
																	<b>Duracion: </b>
																	{servicio.horasMin} minutos
																</div>
																<div className='descripcion-servicio'>
																	<b>Precio: </b>
																	{servicio.precioMin} €
																</div>
																<div className='tipes-servicios-descripcion-servicio'>
																	{servicio.domicilio && (
																		<div className='centradorLeft'>
																			<div className='domicilio-servicioOfrecido-perfilAgencia-nuevo'>
																				Domicilio
																			</div>
																		</div>
																	)}
																	{servicio.shareCare && (
																		<div className='centradorLeft'>
																			<div className='shareCare-servicioOfrecido-perfilAgencia-nuevo'>
																				ShareCare
																			</div>
																		</div>
																	)}
																</div>
															</div>
														)
												)
										)}
									</div>
								</div>
						))
						: null}
				</div>
			</div>
		</>
	);
};
